// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drawer-container[data-v-8e66eed8] {\n  padding: 24px;\n  font-size: 14px;\n  line-height: 1.5;\n  word-wrap: break-word;\n}\n.drawer-container .drawer-title[data-v-8e66eed8] {\n  margin-bottom: 12px;\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 14px;\n  line-height: 22px;\n}\n.drawer-container .drawer-item[data-v-8e66eed8] {\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n  padding: 12px 0;\n}\n.drawer-container .drawer-switch[data-v-8e66eed8] {\n  float: right;\n}", ""]);
// Exports
module.exports = exports;
